// Stripe pricing configuration
// First 500 users get lifetime 40% off

export const EARLY_BIRD_LIMIT = 500;

export const STRIPE_PRICES = {
  monthly: {
    earlyBird: {
      price_id: "price_1ScEuoIlpjbaNVztDtbeSfFU",
      product_id: "prod_TZNgyXZuJpzdku",
      amount: 1199, // $11.99
    },
    regular: {
      price_id: "price_1ScEyVIlpjbaNVztxtDlcTDr",
      product_id: "prod_TZNjyUrTvbcWH6",
      amount: 1999, // $19.99
    },
    interval: "month" as const,
  },
  yearly: {
    earlyBird: {
      price_id: "price_1ScEuqIlpjbaNVztQY40dBzd",
      product_id: "prod_TZNgicF3CrgQ1E",
      amount: 11999, // $119.99
    },
    regular: {
      price_id: "price_1ScEyWIlpjbaNVztGk9QsNGW",
      product_id: "prod_TZNkca77wajj7n",
      amount: 19900, // $199
    },
    interval: "year" as const,
  },
} as const;

export type PricingPlan = keyof typeof STRIPE_PRICES;
